import SignupComponent from '@forwardflow/components/Signup'

const Signup = () => {
   return (
      <>
         <div className="absolute top-10 left-10 w-[calc(100%-80px)] flex justify-between items-center z-10"></div>
         <SignupComponent />
      </>
   )
}
export default Signup
